import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SiteDeletionFormComponent } from '@portal-core/sites/components/site-deletion-form/site-deletion-form.component';

@NgModule({
  declarations: [
    SiteDeletionFormComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  exports: [
    SiteDeletionFormComponent
  ]
})
export class SiteDeletionFormModule { }
